export default {
  // This function sanitizes the text given. First replace is removing "/share" from the given URL as its causing a bug in the APP. Second replacement is adding a hyperlink to the mentions.
  replace: function (comment, appName) {
    let replacedComment = comment
    replacedComment = replacedComment.replace(/engineering\.com\/share/g, 'engineering.com')
    // Second replace will target the scenario when @ is preceded by a blank space
    // Third replace will target the scenario when @ is preceded by > (beggining of a string)
    // In both the regex pattern will match and extract the name of the mentioned user 😀
    const linktag = `<a href="${appName}/profile/$1" target="_blank">@$1</a>`
    replacedComment = replacedComment.replace(/[ ]@([a-zA-Z0-9_.]{1,31})/g, ` ${linktag}`)
    replacedComment = replacedComment.replace(/[>]@([a-zA-Z0-9_.]{1,31})/g, `> ${linktag}`)

    return replacedComment
  }
}
